import { createContext, useContext } from 'react'
import type { AxiosRequestOptions } from '@capture/client-api/src/orval/customInstance'
import type { RequiredCommonQueryParams } from '~/@types/backend-types'
import type { HostType } from './api'

export interface APIConfigContextValue {
    /**
     * Common query parameters for all API requests
     * Includes: key, client_v, device_id, app_lang
     */
    commonParams: RequiredCommonQueryParams

    /**
     * Get request options for a specific host type
     * @param hostType - Type of host (app, thumb, video, poll)
     */
    getRequestOptionsForHost: (hostType: HostType) => AxiosRequestOptions
}

export const APIConfigContext = createContext<
    APIConfigContextValue | undefined
>(undefined)

export function useAPIConfigContext(): APIConfigContextValue {
    const config = useContext(APIConfigContext)

    if (config === undefined) {
        throw new Error('Missing APIConfigContext.Provider in the tree')
    }

    return config
}
